import React from 'react';
import SurveyStepContainer from './SurveyStepContainer';
import { SurveyStepProvider } from './SurveyStepContext';

const SurveyStep = () => {
  return (
    <SurveyStepProvider>
      <SurveyStepContainer />
    </SurveyStepProvider>
  );
};

export default SurveyStep;
